// extracted by mini-css-extract-plugin
module.exports =  {"text-align-center":"_0d624b9a27--text-align-center--wS6Cz","text-align-right":"_0d624b9a27--text-align-right--EMFbI"};